import type { Location } from "vue-router";
import { listProofreadingWorkManuscripts } from "@/lib/api/proofreading";
import { useProofreadingBasicStore } from "@/stores/proofreadingBasic";

/**
 * 修正反映画面へ直接入ったとき、ウィザード前提が揃っていなければ戻す先を決める。
 * 原稿選択も work も無い場合はタイプ選択（校正トップ）へ。
 */
export async function resolveProofreadingReviseRouteRedirect(
  novelId: string,
): Promise<Location | null> {
  const store = useProofreadingBasicStore();
  const { manuscriptIds } = await listProofreadingWorkManuscripts(novelId);
  const hasWork = manuscriptIds.length > 0;
  const hasSelectedManuscripts = store.selectedManuscriptKeys.length > 0;

  if (!hasWork && !hasSelectedManuscripts) {
    return {
      name: "proofreadingSelectType",
      params: { novelId },
    };
  }

  return null;
}
